import { HaNDetailsContext, useRoomsRequest } from "@lib/logic";
import { getAllMeetingRoomSuggestionsUnfilteredForRequest, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { PanelStack } from "../../shared/PanelStack/PanelStack";
import { RoomBookingPage } from "./RoomBookingPage";
import { RoomInfoPage } from "./RoomInfoPage";
import { RoomInviteesPage } from "./RoomInviteesPage";
import { RoomSensorInfoPage } from "./RoomSensorInfoPage";

export const RoomDetails = () => {
  const { selection } = useRequiredContext(HaNDetailsContext);

  if (selection.kind !== "room") return null;

  return <RoomDetailsContent roomId={selection.id} />;
};

// Looks the room up among all of the window's rooms, which keeps a room that was just booked, so its details stay
// on screen while they slide closed
const RoomDetailsContent = ({ roomId }: { roomId: string }) => {
  const request = useRoomsRequest();
  const room = useAppSelector(state =>
    getAllMeetingRoomSuggestionsUnfilteredForRequest(state, request).find(r => r.id === roomId),
  );

  if (!room) return null;

  return (
    <PanelStack initial="info">
      <PanelStack.Page pageId="info">
        <RoomInfoPage room={room} />
      </PanelStack.Page>

      <PanelStack.Page pageId="sensorInfo">
        <RoomSensorInfoPage />
      </PanelStack.Page>

      <PanelStack.Page pageId="booking">
        <RoomBookingPage room={room} />
      </PanelStack.Page>

      <PanelStack.Page pageId="invitees">
        <RoomInviteesPage room={room} />
      </PanelStack.Page>
    </PanelStack>
  );
};
